import { buildOpportunityCoworkDeeplink } from "@cp/toolkit";
import { HasInternalRole } from "@qw/auth";
import { Button, ClaudeIcon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";

// Hands the opportunity off to a desktop Cowork session via deeplink. Internal-only —
// the deeplink targets internal operator tooling (the QuoteWell connector), and the
// inbox app also serves carriers, so gate it the same way the web button does.
export const OpenOpportunityInClaudeButton = ({ opportunityId }: { opportunityId: string }) => (
  <HasInternalRole>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button asChild variant="ghost" size="xs" display="icon">
          <a href={buildOpportunityCoworkDeeplink(opportunityId)} aria-label="Open in Claude">
            <ClaudeIcon />
          </a>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Open in Claude</TooltipContent>
    </Tooltip>
  </HasInternalRole>
);
